let mixin = {
  data() {
    return {
      page: 0,
      total: 0,
      finished: false,
      isListLoading: false,
    }
  },
  methods: {
    dealListPage({ key, list, total }) {
      this.isListLoading = false
      if (!this.page) {
        this[key] = list
      } else {
        this[key].push(...list)
      }
      this.page++
      if (this[key].length === total) {
        this.finished = true
      }
      console.log(this[key])
    },
    checkListStatus() {
      if (this.finished) return true
      if (this.isListLoading) return true
      this.isListLoading = true
      return false
    },
    _resetPage() {
      this.page = 0
      this.isListLoading = false
      this.finished = false
    },
  },
}
export default mixin
